"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerUIActivePortSerialization = void 0;
class ChargerUIActivePortSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        return copy;
    }
}
exports.ChargerUIActivePortSerialization = ChargerUIActivePortSerialization;
